import { Fragment } from 'react/jsx-runtime';
import { useLocation, Link } from 'react-router';

import { ShellHeaderSlot } from './shell-slots';
import { TenantMenu } from './tenant-menu';

import {
    Breadcrumb,
    BreadcrumbItem,
    BreadcrumbLink,
    BreadcrumbList,
    BreadcrumbPage,
    BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';
import { Separator } from '@/components/ui/separator';
import { useCurrentTenant } from '@/context/tenant-registry-context';

export function Header() {
    const location = useLocation();
    const { entry: currentTenant } = useCurrentTenant();

    const getBreadcrumbs = () => {
        const path = location.pathname;
        const segments = path.split('/').filter(Boolean);
        const breadcrumbs: { label: string; href?: string }[] = [];

        if (segments[0] === 'profile') {
            breadcrumbs.push({ label: 'User Settings' });
            breadcrumbs.push({ label: 'General' });
        } else if (segments[0] === 'tenants') {
            // /tenants/:tenantId - Cases page
            if (segments.length >= 2 && segments[1] !== 'create') {
                breadcrumbs.push({ label: 'Cases' });
            }
        } else if (segments[0] === 'settings') {
            // /settings/tenant/:tenantId/[general|members|billing]
            const tenantName = currentTenant?.tenant.name ?? 'Organization';
            breadcrumbs.push({ label: 'Settings' });

            if (segments[1] === 'tenant' && segments[2]) {
                const settingsBasePath = `/settings/tenant/${segments[2]}`;

                if (segments[3] === 'general' || !segments[3]) {
                    breadcrumbs.push({ label: tenantName });
                } else if (segments[3] === 'members') {
                    breadcrumbs.push({ label: tenantName, href: settingsBasePath });
                    breadcrumbs.push({ label: 'Members' });
                } else if (segments[3] === 'billing') {
                    breadcrumbs.push({ label: tenantName, href: settingsBasePath });
                    breadcrumbs.push({ label: 'Billing' });
                }
            }
        }

        return breadcrumbs;
    };

    const breadcrumbs = getBreadcrumbs();

    return (
        <header className="flex h-14 shrink-0 items-center gap-2 border-b px-4">
            <TenantMenu />
            {breadcrumbs.length > 0 && (
                <div className="hidden md:block">
                    <Separator orientation="vertical" className="mx-2 h-4" />
                    <Breadcrumb>
                        <BreadcrumbList>
                            {breadcrumbs.map((crumb, index) => (
                                <Fragment key={index}>
                                    {index > 0 && <BreadcrumbSeparator />}
                                    <BreadcrumbItem>
                                        {crumb.href ? (
                                            <BreadcrumbLink asChild>
                                                <Link to={crumb.href}>{crumb.label}</Link>
                                            </BreadcrumbLink>
                                        ) : (
                                            <BreadcrumbPage>{crumb.label}</BreadcrumbPage>
                                        )}
                                    </BreadcrumbItem>
                                </Fragment>
                            ))}
                        </BreadcrumbList>
                    </Breadcrumb>
                </div>
            )}
            {/* Pages project header content here via <ShellHeader> —
                see shell-slots.tsx. Empty (but space-filling) until a
                page mounts one. */}
            <ShellHeaderSlot />
        </header>
    );
}
